/* eslint-disable max-len */
import React from 'react';
import { Document, Page } from 'react-pdf/dist/entry.webpack';
import { Event } from '../../GAnalytics';

export default class Main extends React.Component {
	constructor() {
		super();

		this.state = {
			modalIsOpen: false,
			numPages: null,
			pageNumber: 1
		};
	
		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	openModal() {
		this.setState({modalIsOpen: true});
	}
	
	afterOpenModal() {
		// references are now sync'd and can be accessed.
		this.subtitle.style.color = '#f00';
	}
	
	closeModal() {
		this.setState({modalIsOpen: false});
	}
	
	onDocumentLoadSuccess = (document) => {
		const { numPages } = document;
		this.setState({
			numPages,
			pageNumber: 1
		});		
	};

	changePage = offset => this.setState(prevState => ({
		pageNumber: prevState.pageNumber + offset
	}));

	previousPage = () => {
		this.changePage(-1);
		Event('Manual', 'PreviousPage', 'Mudou de pagina');
	};

	nextPage = () => {
		this.changePage(1);
		Event('Manual', 'NextPage', 'Mudou de pagina');
	};

	HasDownloaded= () => {
		Event('Manual', 'Download', 'Fez download');
	};

	render() {
		const { numPages, pageNumber } = this.state;
		return (
			<div>

				<div className="container cs-card Manual-box">
					<h2 style={{textAlign: "center"}}>Manual</h2>
					<hr />
					<div className="grid-pdf-container center">
						<button
							className="page-button"
							type="button"
							disabled={pageNumber <= 1}
							onClick={this.previousPage}>
							<img src="/page_back.png" width="50" ></img>
						</button>
						<Document
							className="cs-card"
							file="/manual.pdf"
							onLoadSuccess={this.onDocumentLoadSuccess}>
							<Page pageNumber={pageNumber} renderMode="svg" horizontalRuler="true" />
						</Document>

						<button
							className="page-button"
							type="image"
							disabled={pageNumber >= numPages}
							onClick={this.nextPage}>
							<img src="/page_next.png" width="50" ></img>
						</button>
					</div>
					<p className="center">
						{pageNumber || (numPages ? 1 : '--')} de {numPages || '--'}
					</p>
					<a href='/manual.pdf' download className="center" onClick={this.HasDownloaded}>Download do Manual</a>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Manual/Main.js